<template>
  <div id="app">
    <TelegramLogin />
  </div>
</template>

<script>
import TelegramLogin from './components/TelegramLogin.vue';

export default {
  name: 'App',
  components: {
    TelegramLogin,
  },
};
</script>
